export default "__VITE_ASSET__ByU60DRW__"